import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { API_V2 } from '../api.conf';
import { CompanyStore } from '../../models/backend/company-store';
import { Service } from '../../models/backend/service';
import { Category } from '../../models/backend/category';
import { Employee } from '../../models/backend/employee';
import { ServicesSlotsData } from '../../models/backend/services-slots-data';
import { SlotsHttpParams } from '../../interfaces';

@Injectable()
export class StoreApiService {
  constructor(private http: HttpClient, @Inject(API_V2) private api: string) {}

  private get basePath() {
    return `${this.api}/public`;
  }

  getStores(companyUuid: string): Observable<CompanyStore[]> {
    return this.http.get<CompanyStore[]>(`${this.basePath}/companies/${companyUuid}/stores`);
  }

  getServices(companyUuid: string, storeUuid: string): Observable<Service[]> {
    return this.http.get<Service[]>(`${this.basePath}/companies/${companyUuid}/stores/${storeUuid}/services`);
  }

  getCategories(companyUuid: string, storeUuid: string): Observable<Category[]> {
    return this.http.get<Category[]>(`${this.basePath}/companies/${companyUuid}/stores/${storeUuid}/categories`);
  }

  getEmployees(companyUuid: string, storeUuid: string): Observable<Employee[]> {
    return this.http.get<Employee[]>(`${this.basePath}/companies/${companyUuid}/stores/${storeUuid}/employees`);
  }

  getSlots(companyUuid: string, storeUuid: string, paramsSource: SlotsHttpParams): Observable<ServicesSlotsData> {
    const paramsString = {
      startDate: paramsSource.startDate,
      endDate: paramsSource.endDate,
      services: JSON.stringify(paramsSource.services),
    };
    const params = new HttpParams({ fromObject: paramsString });

    return this.http.get<ServicesSlotsData>(`${this.basePath}/companies/${companyUuid}/stores/${storeUuid}/slots`, {
      params,
    });
  }
}
